import { getConfigValue } from './env';

const DEFAULT_ALLOWED_HOST_SUFFIXES = ['ardshinbank.am'];

function getAllowedHostSuffixes(): string[] {
    const configured = getConfigValue('REACT_APP_ALLOWED_REDIRECT_ORIGINS');
    if (!configured) {
        return DEFAULT_ALLOWED_HOST_SUFFIXES;
    }
    return configured
        .split(',')
        .map((entry) => entry.trim())
        .filter(Boolean)
        .map((entry) => {
            try {
                if (entry.includes('://')) {
                    return new URL(entry).hostname;
                }
            } catch {
                // fall through
            }
            return entry.replace(/^\.+/, '');
        });
}

export function isAllowedPartnerRedirect(url: string | null | undefined): boolean {
    if (!url || typeof url !== 'string') {
        return false;
    }
    try {
        const { protocol, hostname } = new URL(url);
        if (protocol !== 'https:' && protocol !== 'http:') {
            return false;
        }
        if (
            process.env.NODE_ENV === 'development' &&
            (hostname === 'localhost' || hostname === '127.0.0.1')
        ) {
            return true;
        }
        const suffixes = getAllowedHostSuffixes();
        return suffixes.some(
            (suffix) => hostname === suffix || hostname.endsWith(`.${suffix}`)
        );
    } catch {
        return false;
    }
}

export function navigateToPartnerRedirect(
    url: string,
    { onBlocked }: { onBlocked?: (url: string) => void } = {}
): boolean {
    if (!isAllowedPartnerRedirect(url)) {
        onBlocked?.(url);
        return false;
    }
    window.location.href = url;
    return true;
}
